export const AGENT_PROMPTS: Record<string, string> = {
  'agent-packet': [
    '# MCP Scraper Agent Packet Prompt',
    '',
    'Use MCP Scraper as the evidence layer. Run the agent-packet workflow for the target keyword/domain, then treat `evidence.json`, `sources.csv`, and `competitors.csv` as source of truth.',
    '',
    'Do not invent citations. If a recommendation is not supported by the packet, mark it as an assumption. Turn the evidence into a concise SEO brief, an implementation task list, and content recommendations tied to source rows.',
  ].join('\n'),
  'local-competitive-audit': [
    '# MCP Scraper Local Competitive Audit Prompt',
    '',
    'Run the local-competitive-audit workflow for the niche and markets. Use the city summary, competitor CSV, and review-insight CSV to identify market difficulty, review themes, GBP category patterns, and weak competitors.',
    '',
    'Ground recommendations in Maps rank position, review count, star rating, categories, profile details, and review topics. Do not overstate heuristic opportunity scores.',
  ].join('\n'),
  'directory-workflow': [
    '# MCP Scraper Directory Workflow Prompt',
    '',
    'Use directory_workflow when the user wants cities selected by population and Google Maps candidates per city. Keep query and location separate. Preserve result_position, source_location, review stars/count, categories, and profile URLs for downstream CSV or directory use.',
  ].join('\n'),
  'map-comparison': [
    '# MCP Scraper Maps Comparison Prompt',
    '',
    'Run the map-comparison workflow when the user wants to compare local Maps competitors in a city or across selected markets. Use `maps-results.csv`, `map-comparison.csv`, and `profile-insights.csv` as source of truth.',
    '',
    'Ground recommendations in result_position, review_stars, review_count, category, website presence, review topics, and profile attributes. Treat review gaps and missing websites as opportunity signals, not guaranteed ranking factors.',
  ].join('\n'),
  'serp-comparison': [
    '# MCP Scraper SERP Comparison Prompt',
    '',
    'Run the serp-comparison workflow when the user wants to know why competitors outrank a page or what the SERP rewards. Use organic results, extracted page headings, PAA questions, and AI Overview citations before making recommendations.',
    '',
    'Tie each recommendation to `content-gaps.csv`, `page-comparison.csv`, `paa-questions.csv`, or `ai-overview-citations.csv`. Do not invent missing sections or citations.',
  ].join('\n'),
  'paa-expansion-brief': [
    '# MCP Scraper PAA Expansion Brief Prompt',
    '',
    'Run the paa-expansion-brief workflow when the user wants to figure out what to write from People Also Ask expansion. Use `section-map.csv` to structure the brief and `paa-questions.csv` for exact customer-language headings.',
    '',
    'Answer the highest-priority questions directly, preserve source URLs when present, and separate evidence-backed sections from assumptions.',
  ].join('\n'),
  'ai-overview-language': [
    '# MCP Scraper AI Overview Language Prompt',
    '',
    'Run the ai-overview-language workflow when the user wants to know how to phrase content for AI Overview inclusion. Use `claim-patterns.csv`, `language-guidance.csv`, `ai-overview-citations.csv`, and PAA follow-ups as evidence.',
    '',
    'Recommend concise answer blocks, criteria/step language, citation hooks, and follow-up sections. Do not claim the target will be cited; frame the output as evidence-based language guidance.',
  ].join('\n'),
  'ai-citation-monitor': [
    '# MCP Scraper AI Citation Monitor Prompt',
    '',
    'Use search_serp and harvest_paa to check whether the target brand/domain appears in AI Overview citations, organic results, People Also Ask sources, local pack, forums, and videos. Save evidence before summarizing trends or gaps.',
  ].join('\n'),
  'serp-brief': [
    '# MCP Scraper SERP Brief Prompt',
    '',
    'Use live SERP, PAA, AI Overview, forum, video, and source evidence to create a writer brief. Tie each recommended section to evidence rows and identify missing proof, entities, comparisons, and customer questions.',
  ].join('\n'),
}

export function listPrompts(): string[] {
  return Object.keys(AGENT_PROMPTS).sort()
}

export function renderPrompt(name: string): string {
  const prompt = AGENT_PROMPTS[name]
  if (!prompt) throw new Error(`Unknown prompt "${name}". Available: ${listPrompts().join(', ')}`)
  return prompt
}
